import {
  Box,
  Coin,
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Icon,
  Link,
} from '@customerio/pluma-components/react';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { sentryCaptureException } from '@/utils/sentry';

type ErrorPageProps = { error?: unknown; title?: string; description?: ReactNode };

export function ErrorPage({ error, title, description }: ErrorPageProps) {
  useEffect(() => {
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- existing effect pattern before this rule was enforced strictly; avoid adding new cases
    if (error != null) {
      sentryCaptureException(error);
    }
  }, [error]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      flexGrow="1"
      h="full"
      style={{ minHeight: '200px' }}
    >
      <EmptyState>
        <EmptyStateGraphic>
          <Coin size="lg" shape="rounded-square" colorVariant="red">
            <Icon name="critical" color="inherit" />
          </Coin>
        </EmptyStateGraphic>
        <EmptyStateTitle>{title ?? "This page couldn't load"}</EmptyStateTitle>
        <EmptyStateDescription>
          {description ?? (
            <>
              There was a problem loading this page. If this problem continues,{' '}
              <Link href="mailto:win@customer.io" isExternal>
                please contact our support team
              </Link>
              .
            </>
          )}
        </EmptyStateDescription>
      </EmptyState>
    </Box>
  );
}
